import script from "./ChooseWeights.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseWeights.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseWeights.vue?vue&type=style&index=0&id=05d6a1c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d6a1c4"]])

export default __exports__